/**
 * @file
 * A JavaScript file containing the tabbed functionality
 */

(function (Drupal, $) {
  Drupal.behaviors.tabbed = {
    attach: function (context) {
      "use strict";
      $(once("tabbed-enabled", ".tabbed__links", context))
        .addClass("tabbed-enabled")
        .each(function (ind, el) {
          $(el)
            .find("a")
            .each(function (index, anchor) {
              $(anchor).on("click", function (e) {
                e.preventDefault();
                tab_click(this);
              });
            });
        });

      tabc = getUrlParams()["tab"];
      if (tabc) {
        tabc = tabc.toLowerCase().split("#")[0];
        var elem = "a[data-tab='" + tabc + "']";
        if ($(elem).length) {
          tab_click(elem);
        }
      }

      let isProcessing = false;
      $(document).off('ajaxComplete.tabbedSuccess').on('ajaxComplete.tabbedSuccess', function(event, xhr, settings) {
        // Prevent multiple executions
        if (!isProcessing) {
          isProcessing = true;
          
          setTimeout(function() {
            if ($(".tabbed__links a.active").length) {
              $(".tabbed__links--button").text($(".tabbed__links a.active").text());
              console.log($(".tabbed__links a.active").text());
              
              if (
                drupalSettings.views &&
                drupalSettings.views.ajaxViews
              ) {
                var ajaxViews = drupalSettings.views.ajaxViews;
                Object.keys(ajaxViews || {}).forEach(function (i) {
                  if (
                    ajaxViews[i]["view_name"] == "perfomance_prices" &&
                    (ajaxViews[i]["view_display_id"] == "page_1" ||
                      ajaxViews[i]["view_display_id"] == "perfomance_page")
                  ) {
                    actOnUrlTabParam();
                  }
                });
              }
            }
            
            // Reset the flag
            isProcessing = false;
          }, 100);
        }
      });

      $(once("mobile-button-ready", ".tabbed__links--button", context))
        .on("click", function () {
          if (window.matchMedia("(max-width: 920px)").matches) {
            $(this).toggleClass("active");
            $(".tabbed__links").slideToggle(300);
          }
        });

      $(".tabbed__links a").on("click", function () {
        if (window.matchMedia("(max-width: 920px)").matches) {
          var text = $(this).text();
          $(".tabbed__links--button").text(text);
          $(".tabbed__links--button").removeClass("active");
          $(".tabbed__links").slideUp(300);
        }
      });
    },
  };

  function tab_click(tab) {
    var hash = window.location.hash;
    var tabc = $(tab).data("tab");
    if (hash) {
      window.history.pushState("page2", document.title, "?tab=" + tabc + hash);
    } else {
      window.history.pushState("page2", document.title, "?tab=" + tabc);
    }

    $(tab).siblings().removeClass("active");
    $(tab).addClass("active");
    var tabbed = $(tab).closest(".tabbed");
    $(tabbed).find(".tabbed__panel").removeClass("active");
    $(tabbed)
      .find(".tabbed__panel.tab-" + tabc)
      .addClass("active");
  }

  var tabc = null;
  function actOnUrlTabParam() {
    tabc = getUrlParams()["tab"];
    if (tabc) {
      tabc = tabc.toLowerCase().split("#")[0];
      var elem = "a[data-tab='" + tabc + "']";

      if ($(elem).length) {
        tab_click(elem);
        $("html, body").animate(
          {
            scrollTop: $(elem).offset().top - 150,
          },
          1000,
          "swing"
        );
      }
    }
  }
})(Drupal, jQuery);
